import { render, staticRenderFns } from "./gardenList.vue?vue&type=template&id=66332558&"
import script from "./gardenList.vue?vue&type=script&lang=js&"
export * from "./gardenList.vue?vue&type=script&lang=js&"
import style0 from "./gardenList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports